import type { MenuConfig } from 'alurkerja-ui'
import { useEffect, useMemo, useState } from 'react'
import { TasklistService } from '@/api/tasklist'
import { ClipboardCheck, HouseIcon, List, ListTodo, UserRound, Users, Workflow } from 'lucide-react'
import { UserService } from '@/api/user'
import { Roles } from '@/utils/constants/roles'
import dashboardMetabaseRoutes from '@/utils/configs/dashboardMetabaseRoutes'

export interface ExtendedMenuConfig extends Omit<MenuConfig, 'child'> {
  role?: string[]
  child?: ExtendedMenuConfig[]
  id?: string
}

const menu: ExtendedMenuConfig[] = [
  { href: '/', label: 'Home', icon: <HouseIcon /> },
  {
    href: '/master',
    label: 'Master',
    icon: <List />,
    child: [
      {
        href: '/master/employee',
        label: 'Employee',
        icon: <UserRound />,
        role: [Roles.StaffHR, Roles.ManagerHR, Roles.AssistantDirector, Roles.Director],
      },
    ],
  },
  dashboardMetabaseRoutes,
  { href: '/my-task', label: 'My Task', icon: <ListTodo /> },
  { href: '/group-task', label: 'Group Task', icon: <Users /> },
  {
    href: '/my-request',
    label: 'My Request',
    icon: <ClipboardCheck />,
    child: [
      { href: '/my-request/active', label: 'Active' },
      { href: '/my-request/completed', label: 'Completed' },
    ],
  },
]

export const useGetMenu = ({ role }: { role: string | undefined }) => {
  const rolesArray = role

  const { data: profile } = UserService.useGetProfile()
  const { data: tasks, isLoading: isLoadingBusinessProcesses } = TasklistService.useGetProcesses({
    username: profile?.username,
  })
  const [currentMenu, setCurrentMenu] = useState<ExtendedMenuConfig[]>([])

  useEffect(() => {
    if (!tasks) return

    const formattedExtraMenu = tasks
      .filter(item => {
        if (
          rolesArray &&
          (rolesArray.includes(Roles.ManagerHR) ||
            rolesArray.includes(Roles.ManagerSalesOnline) ||
            rolesArray.includes(Roles.ManagerSalesOffline) ||
            rolesArray.includes(Roles.ManagerWarehouse) ||
            rolesArray.includes(Roles.ManagerProduksi) ||
            rolesArray.includes(Roles.ManagerMarketingBranding))
        ) {
          return true
        }
        return item.key !== 'Pengajuan-pemantauan-KPI-GRD'
      })
      .map(item => ({
        href: `/tasklist/${item.key}`,
        label: item.name,
      }))

    const formattedMenu = [
      {
        href: '/pengajuan-izin',
        label: 'Business Process ',
        icon: <Workflow />,
        child: formattedExtraMenu,
      },
    ]

    setCurrentMenu([...menu, ...formattedMenu])
  }, [tasks])

  const filteredMenu = useMemo(() => {
    return currentMenu.map(item => {
      const filteredChildren = item.child?.filter(child => {
        if (child.role) {
          return rolesArray ? child.role.some(r => rolesArray.includes(r)) : false
        }
        return true
      })

      return {
        ...item,
        child: filteredChildren,
      }
    })
  }, [rolesArray, currentMenu])

  return { filteredMenu, isLoadingBusinessProcesses }
}
